module.exports = __webpack_public_path__ + "static/img/3.ed9415c3.jpg";